import React from "react";
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export default function NumberFormatYears(props) {
  const { inputRef, onChange, ...numberFormatProps } = props;

  return (
    <NumberFormat
      {...numberFormatProps}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      isNumericString
      suffix=" years"
    />
  );
}

NumberFormatYears.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/NumberFormatYears.js